<!--
 - Header component HTML
 -
 - @version
 - 4.63.0 DEVOPS-715 order-admin-ui: setup new repo without vertical slicing
 - 4.56.0 OAUI-596 Migrate Large Model Viewer into Angular
 - 4.56.0 OAUI-614 Migrate LMV navigation bar into angular
 -
 - @author Ryan Sweeney <rsweeney@buildcentrix.com>
 - @copyright (c) 2023 Build Centrix
 -->
<div class="viewer-header">
  <div class="row">
    <div class="left col-sm-12 col-md-4">
      <div class="bcx-buttons-container">
        <!--Back Button-->
        <div class="mb-1">
          <bc-atoms-button
            id="btnAddLookahead"
            icon="previous"
            display="block"
            label=" {{'actions.backTo'|translate: { type: ('order.details.description'|translate) } }}"
            title="{{'actions.backTo'|translate: { type: ('order.details.description'|translate) } }}"
            size="small"
            type="default"
            (onButtonClicked)="navigateToManageOrder(orderIndex)"
          >
          </bc-atoms-button>
        </div>
      </div>
    </div>
    <div class="center col-sm-12 col-md-4">
      <!--Page Title-->
      <div class="title">
        <!--Main Title-->
        <div class="main">{{title}}</div>
        <!--Subtitle-->
        <div class="sub">{{subtitle}}</div>
      </div>
    </div>
    <div class="right col-sm-12 col-md-4">
      <div class="bcx-buttons-container"></div>
    </div>
  </div>
</div>
